import { ButtonColor, ButtonVariant, ComponentPosition, FieldVariant } from 'generated/graphql';
import ActionButton from '../../ActionButton';
import type { FieldRendererProps } from '../types';

/**
 * A field rendered as a button.
 *
 * The field's value is where it goes and its first entry in `values` is what
 * it runs, so a button can either navigate or carry out a mutation. Both are
 * passed to the same handler ActionButton uses everywhere else, which takes
 * whichever of the two is set.
 */
export function ButtonUrlField({ field, onRefresh }: FieldRendererProps) {
  return (
    <ActionButton
      actions={[
        {
          code: '',
          description: '',
          group: [],
          query: field.values?.[0] ?? '',
          variables: '',
          url: field.value,
          value: '',
        },
      ]}
      badge={false}
      color={ButtonColor.Primary}
      description=""
      disabled={false}
      icon={field.icon}
      selected={false}
      value={field.label}
      variant={ButtonVariant.Outlined}
      position={ComponentPosition.None}
      asIcon={field.variant === FieldVariant.Standard}
      onMutate={onRefresh}
    />
  );
}
